function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import CompanyCosts from './CompanyCosts';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import elsterService from '../../services/company/elsters.service';
const ClaimGroupClaimList = props => {
  const {
    company_id,
    step_id
  } = useParams();
  const [loading, setLoading] = useState(true);
  const {
    elster,
    setElster,
    fetchElster
  } = elsterService.useCrud(company_id, setLoading, step_id);
  if (loading) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompanyCosts, _extends({
    fetchElster: fetchElster,
    elster: elster,
    setElster: setElster
  }, props)));
};
export default ClaimGroupClaimList;